const PatientForms = () => {
  return <div>patient forms</div>;
};

export default PatientForms;
